<template>
  <div style="height: 100%">
    <Appbar />
    <v-divider></v-divider>
    <router-view></router-view>
    <BottomNavigation />
  </div>
</template>

<script>
// import authService from "@/modules/Authentication/service.js";
import employeeService from "@/modules/Employee/service";
import { mapActions } from "vuex";
import locationService from "@/modules/Location/service.js";
import BottomNavigation from "@/components/BottomNavigation.vue";

export default {
  name: "layout",
  data() {
    return {
      // loading: false,
      location: null,
      authenticated: true,
      polling: null,
    };
  },
  components: { BottomNavigation },
  watch: {
    authenticated(val) {
      if (!val) {
        this.$router.push({ name: "authentication-employee-login" });
      }
    },
  },
  sockets: {
    connect() {
      console.log("socket connected LAYOUT");
      // Make sure to rejoin the channels
      this.joinSocketChannels();
    },
    notification() {
      console.log(
        'this method was fired by the socket server. eg: io.emit("notification", data)'
      );
    },
    message(data) {
      console.log("New message.", data);
    },
    settingChange() {
      console.log("setting Change");
    },
  },
  async created() {
    console.log("home got created");
    const code = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}code`
    );
		if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}timezone`))
			this.$moment.tz.setDefault(localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}timezone`));
    if (!code) {
      return false;
    }
    // if (selectedScreen === "Admin Panel") {
    //   this.$router.push({ name: "home" });
    // } else {
    //   this.$router.push({ name: "clockInOut" });
    // }

    this.joinSocketChannels();

    let localLocation = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}location`
    );
    

    if (localLocation) {
      localLocation = JSON.parse(localLocation);
      // console.log("location", localLocation);

      this.location = (
        await locationService.Terminal.getById(localLocation.id)
      ).data;
      console.log("locationlocationlocationlocation", this.location);
      await this.setLocation(this.location);
    }
    this.checkAuth();
    if (
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}lastEmployeeId`
      )
    ) {
      const employeeId = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}lastEmployeeId`
      );
      console.log("employeeId", employeeId);
      employeeService
        .getById(employeeId)
        .then((response) => {
          this.setEmployee(response.data);
        })
        .catch((error) => {
          throw error;
        });
    }
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    ...mapActions("global", ["setLocation"]),
    checkAuth() {
      if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)) {
        this.authenticated = false;
      }
      this.polling = setTimeout(this.checkAuth, 5000);
    },
    joinSocketChannels() {
      const locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
      const deviceCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`
      );
      const deviceName = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`
      );
      console.log("joinSocketChannels location", locationCode, deviceCode, deviceName);

      if (locationCode && deviceCode) {
        this.$socket.emit("join-location", {
          locationCode,
          deviceCode,
          deviceName,
        });
      }

      //   if (this.$store.getters['global/location']) {
      //     this.$socket.emit('join-organization', {
      //       OrganizationId: this.$store.getters['global/location'].OrganizationId,
      //     });
      //   }
    },
  },
};
</script>

<style>
</style>